import React from 'react';

import Select from 'react-select';
import { shape, func, bool, string } from 'prop-types';

import SellerFeeStructure from './SellerFeeStructure';
import {
  HYBRID,
  ONEPVALUE,
  SELLERSMALL,
  THREEP,
  VENDOR,
  vendorReportOptions,
} from '../../../../constants';
import { CheckBox, ContractInputSelect, ErrorMsg } from '../../../../common';

export default function VendorFeeStructure({
  setFormData,
  setUpdatedFormData,
  formData,
  updatedFormData,
  DropdownIndicator,
  showFooter,
  setSectionError,
  sectionError,
  feeStructureErrors,
  setFeeStructureErrors,
  setVendorSameAsSeller,
  vendorSameAsSeller,
  selectedCurrency,
  contractAddendumDetails,
  checkAddendumData,
  addendumDetails,
}) {
  const vendorField = formData?.fee_structure_vendor_type;
  const sellerField = formData?.fee_structure_seller_type;
  const handleCheckbox = (event) => {
    showFooter(true);
    const vendorId = formData?.fee_structure?.[vendorField]?.id;
    if (event.target.checked) {
      setVendorSameAsSeller(true);
      setFormData({
        ...formData,
        fee_structure: {
          ...formData.fee_structure,
          [vendorField]: {
            ...formData.fee_structure?.[sellerField],
            id: vendorId,
            vendor_billing_report:
              formData.fee_structure?.[vendorField]?.vendor_billing_report,
            vendor_same_as_seller: true,
          },
          [sellerField]: {
            ...formData.fee_structure?.[sellerField],
            vendor_same_as_seller: true,
          },
        },
      });

      setUpdatedFormData({
        ...updatedFormData,
        fee_structure: {
          ...updatedFormData.fee_structure,
          [vendorField]: {
            ...updatedFormData?.fee_structure?.[sellerField],
            vendor_billing_report:
              formData.fee_structure?.[vendorField]?.vendor_billing_report,
            vendor_same_as_seller: true,
          },
        },
      });

      setSectionError({
        ...sectionError,
        [vendorField]: {
          feeType: !(
            formData &&
            formData?.fee_structure?.[vendorField]?.vendor_billing_report
          )
            ? sectionError?.[sellerField]?.feeType
              ? sectionError?.[sellerField]?.feeType + 1
              : 0
            : sectionError?.[sellerField]?.feeType
            ? sectionError?.[sellerField]?.feeType
            : 0,
        },
        [sellerField]: {
          feeType: sectionError?.[sellerField]?.feeType
            ? sectionError?.[sellerField]?.feeType
            : 0,
        },
      });
      setFeeStructureErrors({
        ...feeStructureErrors,
        [vendorField]: {
          ...feeStructureErrors?.[sellerField],
        },
      });
    }
    if (!event.target.checked) {
      setVendorSameAsSeller(false);
      setFormData({
        ...formData,
        fee_structure: {
          ...formData.fee_structure,
          [vendorField]: {
            ...formData.fee_structure[vendorField],
            vendor_same_as_seller: false,
            id: vendorId,
          },
          [sellerField]: {
            ...formData.fee_structure?.[sellerField],
            vendor_same_as_seller: false,
          },
        },
      });
      setUpdatedFormData({
        ...updatedFormData,
        fee_structure: {
          ...updatedFormData.fee_structure,
          [vendorField]: {
            vendor_billing_report:
              formData.fee_structure[vendorField].vendor_billing_report,
            vendor_same_as_seller: false,
          },
        },
      });
    }
  };

  const clearError = (key) => {
    if (!(formData && formData?.fee_structure?.[vendorField]?.[key])) {
      setSectionError({
        ...sectionError,
        [vendorField]: {
          feeType: sectionError?.[vendorField]?.feeType
            ? sectionError?.[vendorField]?.feeType - 1
            : 0,
        },
      });
      setFeeStructureErrors({
        ...feeStructureErrors,
        [vendorField]: {
          ...feeStructureErrors?.[vendorField],
          [key]: '',
        },
      });
    }
  };

  const handleChange = (event, key) => {
    clearError(key);
    showFooter(true);

    setFormData({
      ...formData,
      fee_structure: {
        ...formData.fee_structure,
        [vendorField]: {
          ...formData.fee_structure?.[vendorField],
          [key]: event.value,
        },
      },
    });
    setUpdatedFormData({
      ...updatedFormData,
      fee_structure: {
        ...updatedFormData.fee_structure,
        [vendorField]: {
          ...updatedFormData?.fee_structure?.[vendorField],
          [key]: event.value,
        },
      },
    });
  };

  const generateDropdown = (item) => {
    return (
      <Select
        classNamePrefix={
          !(formData && formData?.fee_structure?.[vendorField]?.[item.key]) &&
          item.isMandatory
            ? 'react-select  form-control-error'
            : 'react-select'
        }
        styles={{
          control: (base, state) => ({
            ...base,
            background:
              !(
                formData && formData?.fee_structure?.[vendorField]?.[item.key]
              ) && item.isMandatory
                ? '#FBF2F2'
                : '#F4F6FC',
            // match with the menu
            // borderRadius: state.isFocused ? '3px 3px 0 0' : 3,
            // Overwrittes the different states of border
            borderColor:
              !(
                formData && formData?.fee_structure?.[vendorField]?.[item.key]
              ) && item.isMandatory
                ? '#D63649'
                : '#D5D8E1',

            // Removes weird border around container
            boxShadow: state.isFocused ? null : null,
            '&:hover': {
              // Overwrittes the different states of border
              boxShadow: state.isFocused ? null : null,
              outlineColor: state.isFocused ? null : null,
            },
          }),
        }}
        placeholder={item.placeholder || 'Select'}
        value={
          formData?.fee_structure?.[vendorField]?.[item.key]
            ? {
                value: formData?.fee_structure?.[vendorField]?.[item.key],
                label: formData?.fee_structure?.[vendorField]?.[item.key],
              }
            : null
        }
        options={vendorReportOptions}
        name={item.key}
        components={{ DropdownIndicator }}
        onChange={(event) => handleChange(event, item.key, 'choices')}
        isDisabled={contractAddendumDetails?.notActive}
      />
    );
  };

  return (
    <>
      {formData?.seller_type?.value === HYBRID ? (
        <div className=" liner-titles spacing mt-3 mb-3">
          {formData?.isNewChannel ? THREEP : VENDOR} Fee Structure
        </div>
      ) : (
        ''
      )}
      {formData?.isNewChannel ? null : (
        <ContractInputSelect className="mb-3">
          <label htmlFor={`${vendorField} Billing Report`}>
            {vendorField} Billing Report
          </label>
          {generateDropdown({
            key: 'vendor_billing_report',
            label: `${vendorField} Billing Report`,
            type: 'choice',
            isMandatory: true,
            placeholder: `Select ${vendorField} Billing Report`,
          })}
          <ErrorMsg>
            {feeStructureErrors?.[vendorField]?.vendor_billing_report}
          </ErrorMsg>
        </ContractInputSelect>
      )}
      {formData?.seller_type?.value === HYBRID ? (
        <CheckBox className="mt-1 mb-4">
          <label className="check-container customer-pannel " htmlFor="step">
            Apply same fee structure as{' '}
            {formData?.isNewChannel ? ONEPVALUE : SELLERSMALL} sales
            <input
              className="checkboxes"
              type="checkbox"
              id="step"
              readOnly
              defaultChecked={
                formData?.fee_structure?.[vendorField]?.vendor_same_as_seller
              }
              onChange={(event) => handleCheckbox(event, 'checkbox')}
            />
            <span className="checkmark" />
          </label>
        </CheckBox>
      ) : (
        ''
      )}

      <SellerFeeStructure
        setFormData={setFormData}
        updatedFormData={updatedFormData}
        setUpdatedFormData={setUpdatedFormData}
        formData={formData}
        DropdownIndicator={DropdownIndicator}
        section={vendorField}
        showFooter={showFooter}
        setSectionError={setSectionError}
        sectionError={sectionError}
        vendorSameAsSeller={vendorSameAsSeller}
        feeStructureErrors={feeStructureErrors}
        setFeeStructureErrors={setFeeStructureErrors}
        selectedCurrency={selectedCurrency}
        contractAddendumDetails={contractAddendumDetails}
        checkAddendumData={checkAddendumData}
        addendumDetails={addendumDetails}
      />
    </>
  );
}

VendorFeeStructure.defaultProps = {
  setUpdatedFormData: () => {},
  setFormData: () => {},
  formData: {},
  updatedFormData: {},
  DropdownIndicator: {},
  showFooter: () => {},
  setSectionError: () => {},
  sectionError: {},
  feeStructureErrors: {},
  setFeeStructureErrors: () => {},
  setVendorSameAsSeller: () => {},
  selectedCurrency: '$ (USD)',
  contractAddendumDetails: {},
  checkAddendumData: false,
  addendumDetails: {},
};

VendorFeeStructure.propTypes = {
  formData: shape({
    fee_structure: shape({}),
  }),
  DropdownIndicator: func,
  setUpdatedFormData: func,
  setFormData: func,
  updatedFormData: shape({}),
  showFooter: func,
  setSectionError: func,
  sectionError: shape({}),
  feeStructureErrors: shape({}),
  setFeeStructureErrors: func,
  setVendorSameAsSeller: func,
  vendorSameAsSeller: bool.isRequired,
  selectedCurrency: string,
  contractAddendumDetails: shape({}),
  checkAddendumData: bool,
  addendumDetails: shape({}),
};
